﻿import './MyProfile.scss';
import { InfoLabel } from './PagesNavBar';
import { Grid, Button } from '@mui/material';
import AddTaskIcon from '@mui/icons-material/AddTask';
import React, { useState, useEffect } from 'react';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import {
  SendRequestStateApprovalEmail,
  GetInsertAgentDeviceState,
  GetListOfAgentDeviceStatuses,
  GetImportantInfo,
  ConfirmAgentDeviceStateExists,
} from '../../api/regedint';
import CircularProgress from '@mui/material/CircularProgress';
import { GetStateList } from 'api/apppackage';
import { useQuery, useMutation } from '@tanstack/react-query';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import NotificationSnackbar from '../../components/Global/NotificationSnackbar/NotificationSnackbar';
import Alert from '@mui/material/Alert';

export default function AgentDevice({ ...props }) {
  const [openNotif, setOpenNotif] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [requestDetails, setRequestDetails] = useState('');
  const [requestState, setRequestState] = useState('');
  const [open, setOpen] = useState(false);
  const [snackBarErrorMsg, setSnackBarErrorMsg] = useState(
    'There was an error sending the Request for State Approval. Please try again.'
  );
  const [confirmADStateLoading, setConfirmADStateLoading] = useState(false);

  //BL-3990 - Agent Device Important Info
  const getImportantInfo = useQuery({
    queryKey: ['GetImportantInfo'],
    queryFn: () => GetImportantInfo()(),
    enabled: props.user != null && props.user.isHO === false,
  });

  const confirmAgentDeviceStateExists = useMutation({
    mutationFn: (data) => ConfirmAgentDeviceStateExists(data)(),
  });

  function agentDeviceImportantInfo() {
    return (
      <Alert severity="warning" color="warning" style={{ backgroundColor: 'rgb(255, 244, 229)' }}>
        {getImportantInfo.data}
      </Alert>
    );
  }

  const getStateQuery = useQuery({
    queryKey: ['GetStateList'],
    queryFn: () => GetStateList()(),
    enabled: props.user != null && props.user.isHO === false,
  });

  const getListOfAgentDeviceStatuses = useQuery({
    queryKey: ['GetListOfAgentDeviceStatuses', props.agentInfo.nationalProducerNumber],
    queryFn: () => GetListOfAgentDeviceStatuses({ ID: props.agentInfo.nationalProducerNumber })(),
    enabled:
      props.user != null && props.user.isHO === false && !!props.agentInfo.nationalProducerNumber,
  });

  const sendRequestStateApprovalEmail = useQuery({
    queryKey: ['SendRequestStateApprovalEmail', requestState],
    queryFn: () =>
      SendRequestStateApprovalEmail(
        props.agentInfo.fullName,
        props.agentInfo.agencyName,
        props.agentInfo.residentState,
        requestState,
        requestDetails
      )(),
    enabled: false,
  });

  useEffect(() => {
    if (sendRequestStateApprovalEmail.isSuccess && sendRequestStateApprovalEmail.data) {
      setSnackBarStatus('success');
      setIsLoading(false);
      setOpen(false);
      setOpenNotif(true);
      getListOfAgentDeviceStatuses.refetch();
    }
  }, [sendRequestStateApprovalEmail.isSuccess, sendRequestStateApprovalEmail.data]);

  useEffect(() => {
    if (sendRequestStateApprovalEmail.isError) {
      setSnackBarStatus('error');
      setIsLoading(false);
      setOpen(false);
      setOpenNotif(true);
    }
  }, [sendRequestStateApprovalEmail.isError]);

  const [snackBarStatus, setSnackBarStatus] = useState('success');

  function HandleRequestStateApprovalEmail() {
    sendRequestStateApprovalEmail.refetch();
  }

  function HandleInsertAgentDeviceState() {
    setIsLoading(true);

    confirmAgentDeviceStateExists.mutate(
      { npn: '', state: requestState },
      {
        onSuccess: (stateExists) => {
          setConfirmADStateLoading(false);

          if (stateExists > 0) {
            setSnackBarStatus('error');
            setSnackBarErrorMsg('The Request for State Approval has already been sent');
            setIsLoading(false);
            setOpen(false);
            setOpenNotif(true);
          } else {
            setSnackBarErrorMsg(
              'There was an error sending the Request for State Approval. Please try again.'
            );
            getInsertAgentDeviceState.mutate(
              {
                npn: props.agentInfo.nationalProducerNumber,
                state: requestState,
                reason: requestDetails,
              },
              {
                onSuccess: () => {
                  HandleRequestStateApprovalEmail();
                },
              }
            );
          }
        },
        onMutate: () => {
          setConfirmADStateLoading(true);
        },
      }
    );
  }

  const getInsertAgentDeviceState = useMutation({
    mutationFn: (data) => GetInsertAgentDeviceState(data)(),
  });

  if (props.user.isHO === true || props.canSubmit == false)
    return (
      <div style={{ textAlign: 'center', margin: '2em', fontSize: 'large' }}>
        No information to display
      </div>
    );

  if (
    getStateQuery.isPending ||
    getStateQuery.isFetching ||
    getListOfAgentDeviceStatuses.isPending ||
    getListOfAgentDeviceStatuses.isFetching
  )
    return <CircularProgress size={64} style={{ marginLeft: '50%', marginTop: '15%' }} />;

  return (
    <>
      <NotificationSnackbar
        status={snackBarStatus}
        openTrigger={openNotif}
        onClose={() => {
          setOpenNotif(false);
        }}
        successMsg={'Successfully sent Request for State Approval'}
        errorMsg={snackBarErrorMsg}
      />

      <div style={{ margin: '1em 0' }}>
        {!getImportantInfo.isPending && !getImportantInfo.isFetching && agentDeviceImportantInfo()}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: '1em 0 0.75em',
          }}
        >
          <div className="infoLabel">{'Face to Face Sales State Request Statuses'}</div>
          {!confirmADStateLoading && (
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddTaskIcon />}
              onClick={() => {
                setOpen(true);
              }}
            >
              Request State Approval
            </Button>
          )}
        </div>
        {getListOfAgentDeviceStatuses.data != null && (
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            {getListOfAgentDeviceStatuses.data.approvals && (
              <InfoLabel
                label="Approved States:"
                data={[getListOfAgentDeviceStatuses.data.approvals]}
                style={{ overflowWrap: 'break-word' }}
              />
            )}
            {getListOfAgentDeviceStatuses.data.pendings && (
              <InfoLabel
                label="Pending States:"
                data={[getListOfAgentDeviceStatuses.data.pendings]}
                style={{ overflowWrap: 'break-word' }}
              />
            )}
            {getListOfAgentDeviceStatuses.data.rejects && (
              <InfoLabel
                label="Declined States:"
                data={[getListOfAgentDeviceStatuses.data.rejects]}
                style={{ overflowWrap: 'break-word' }}
              />
            )}
            {getListOfAgentDeviceStatuses.data.revokes && (
              <InfoLabel
                label="Revoked States:"
                data={[getListOfAgentDeviceStatuses.data.revokes]}
                style={{ overflowWrap: 'break-word' }}
              />
            )}
          </Grid>
        )}

        <ConfirmationDialog
          setRequestState={setRequestState}
          open={open}
          setOpen={setOpen}
          setRequestDetails={setRequestDetails}
          HandleInsertAgentDeviceState={HandleInsertAgentDeviceState}
          isLoading={isLoading || confirmADStateLoading}
          stateList={getStateQuery.data}
          requestState={requestState}
          approvedStates={
            getListOfAgentDeviceStatuses.data?.approvals
              ? getListOfAgentDeviceStatuses.data.approvals.split(',').map((s) => s.trim())
              : []
          }
          pendingStates={
            getListOfAgentDeviceStatuses.data?.pendings
              ? getListOfAgentDeviceStatuses.data.pendings.split(',').map((s) => s.trim())
              : []
          }
          declinedStates={
            getListOfAgentDeviceStatuses.data?.rejects
              ? getListOfAgentDeviceStatuses.data.rejects.split(',').map((s) => s.trim())
              : []
          }
          revokedStates={
            getListOfAgentDeviceStatuses.data?.revokes
              ? getListOfAgentDeviceStatuses.data.revokes.split(',').map((s) => s.trim())
              : []
          }
        />
      </div>
    </>
  );
}

function ConfirmationDialog({ ...props }) {
  const [state, setState] = useState('');

  const handleStateChange = (event) => {
    setState(event.target.value);
    props.setRequestState(event.target.value);
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '100%', maxHeight: 500 } }}
      maxWidth="xs"
      open={props.open}
      onClose={() => {
        props.setOpen(false);
      }}
    >
      <DialogContent dividers>
        <div style={{ margin: '1em 0', fontSize: 'larger' }}>Request State</div>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">State</InputLabel>
          <Select
            labelId="demo-simple-select-label-requeststate"
            id="demo-simple-select-requeststate"
            value={state}
            label="State"
            onChange={handleStateChange}
          >
            {props.stateList != null &&
              props.stateList.map((state, index) => {
                const isApproved = props.approvedStates?.includes(state.value);
                const isPending = props.pendingStates?.includes(state.value);
                const isDeclined = props.declinedStates?.includes(state.value);
                const isRevoked = props.revokedStates?.includes(state.value);
                return (
                  <MenuItem
                    key={'state-' + index}
                    value={state.value}
                    disabled={isApproved || isPending || isDeclined || isRevoked}
                  >
                    {state.text}
                    {isApproved && (
                      <span style={{ marginLeft: 8, fontSize: '0.75em', color: 'green' }}>
                        Approved
                      </span>
                    )}
                    {isPending && (
                      <span style={{ marginLeft: 8, fontSize: '0.75em', color: '#ed6c02' }}>
                        Pending
                      </span>
                    )}
                    {isDeclined && (
                      <span style={{ marginLeft: 8, fontSize: '0.75em', color: '#d32f2f' }}>
                        Declined
                      </span>
                    )}
                    {isRevoked && (
                      <span style={{ marginLeft: 8, fontSize: '0.75em', color: '#757575' }}>
                        Revoked
                      </span>
                    )}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
        <div>
          <div style={{ margin: '1em 0', fontSize: 'larger' }}>Request Details</div>
          <TextField
            id="outlined-multiline-flexible"
            placeholder="Input request details here..."
            sx={{ width: '100%', height: '10em', overflow: 'auto' }}
            multiline
            onChange={(e) => {
              props.setRequestDetails(e.target.value);
            }}
            rows={4}
          />
        </div>
      </DialogContent>
      <DialogActions>
        {!props.isLoading && (
          <Button
            autoFocus
            onClick={() => {
              props.setOpen(false);
            }}
          >
            Cancel
          </Button>
        )}
        {props.isLoading ? (
          <CircularProgress />
        ) : (
          <Button
            disabled={props.requestState === ''}
            variant="contained"
            color="primary"
            onClick={props.HandleInsertAgentDeviceState}
          >
            Request Approval
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
